import { useRegisterSW } from 'virtual:pwa-register/react';
import { motion, AnimatePresence } from 'framer-motion';

export default function UpdatePrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      if (r) setInterval(() => r.update(), 60 * 60 * 1000);
    },
  });

  return (
    <AnimatePresence>
      {needRefresh && (
        <motion.div
          initial={{ opacity: 0, y: 80 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 80 }}
          className="fixed bottom-24 left-4 right-4 z-[200] flex items-center justify-between gap-3 rounded-2xl border-2 border-ocean bg-[#0e0e1f]/95 px-4 py-3 shadow-game-card backdrop-blur-sm"
        >
          <div className="flex items-center gap-3">
            <span className="text-xl">🔄</span>
            <div>
              <p className="font-body text-sm font-bold text-white">Nova versão disponível</p>
              <p className="font-body text-xs text-white/60">Atualiza para obteres as últimas melhorias.</p>
            </div>
          </div>
          <button
            onClick={() => updateServiceWorker(true)}
            className="flex-shrink-0 rounded-xl bg-ocean px-4 py-2 font-body text-sm font-bold text-white active:scale-95"
          >
            Atualizar
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
